import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import stars from "../../../RichImages/stars.svg";

const TermsCondition = () => {
  return (
    <>
      <Navbar />
      <div className="tc-container">
        <div className="d-flex justify-content-center align-items-center ">
          <div className="backgroundoftitle">
            <img
              className="game-icons-img"
              src={stars}
              alt="https://laksh365.com/"
            />
            <h1 class="mb-0 ms-2 me-2 rich-game-title backgroundoftitle">
              Terms and Conditions
            </h1>
            <img
              className="game-icons-img"
              src={stars}
              alt="https://laksh365.com/"
            />
          </div>
        </div>

        <section className="tc-section">
          <h2 className="tc-heading">
            Kalyan, Main Bazar Jodi Chart Satta Matka
          </h2>
          <p className="tc-text">
            Record Old History Historical Data Bracket Results Chart Online Live
            Book Digits Numbers
          </p>
        </section>

        <section className="tc-section">
          <h2 className="tc-heading">Withdraw Information</h2>
          <ul className="tc-list">
            <li className="tc-item">
              If users entered wrong bank details, Laksh365 is not responsible.
            </li>
            <li className="tc-item">
              Before requesting withdraw, re-check your bank details.
            </li>
            <li className="tc-item">
              After withdraw request, if there is no valid wallet balance, the
              request will be auto-declined.
            </li>
          </ul>
        </section>

        <section className="tc-section">
          <h2 className="tc-heading">Unfair Bets</h2>
          <p className="tc-text">
            If admin finds any unfair bets, blocking of digits, canning or match
            fix bets, admin has all rights to take necessary actions to block
            the user.
          </p>
        </section>

        <section className="tc-section">
          <h2 className="tc-heading">Cheating & Fraudulent Activity</h2>
          <p className="tc-text">
            If admin finds any cheating, hacking, or phishing attempts, admin
            has full rights to take strict action and block the user
            permanently.
          </p>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default TermsCondition;
